import { FieldArray } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { Fragment } from 'react'
import { Trash } from 'react-bootstrap-icons'
import Input from '../../../../FormComponents/Input'
import Switch from '../../../../FormComponents/Switch'
import Textarea from '../../../../FormComponents/Textarea'
import ReportSection from '../../../../../models/ReportSection'
import { useReadOnly } from '../../../../../contexts/ReadOnlyContext'

export default observer(function LearningRecommendations({ values, setFieldValue, handleChange, handleBlur }) {
  const readOnly = useReadOnly()

  return (
    <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-2xl p-4 mt-4">
      <div className="flex justify-between items-center mb-8">
        <p className="font-bold text-xl dark:text-white">Learning & Recommendation</p>
        <Switch name="learning_visible" value={values.learning_visible} onChange={({ target: { checked }}) => setFieldValue('learning_visible', checked, true)} eyeSwitch />
      </div>
      {
        values.learning_visible && (
          <div className="mt-8 mb-4">
            <FieldArray name="learning_sections_attributes">
            {({ insert, remove, push }) => (
              <Fragment>
                <div>
                  { values.learning_sections_attributes.map((section, index) =>
                    <div key={index}>
                      {!section._destroy &&
                        <Fragment>
                          <div className="flex justify-between">
                            <p className="font-bold dark:text-white">Section {index + 1}</p>
                            {!readOnly && <button className="dark:text-white" onClick={() => setFieldValue(`learning_sections_attributes.${index}._destroy`, true, true)}><Trash /></button>}
                          </div>

                          <Input
                            label="Title"
                            placeholder="Write something here"
                            name={`learning_sections_attributes.${index}.title`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.learning_sections_attributes[index]?.title}
                          />

                          <Textarea
                            className={'rounded-lg px-4 w-full'}
                            rows={4}
                            label="Free text"
                            placeholder="Write something here"
                            name={`learning_sections_attributes.${index}.free_text`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.learning_sections_attributes[index]?.free_text}
                          />
                        </Fragment>
                      }
                    </div>
                  )}
                </div>
                {!readOnly && (
                  <div className="flex justify-end">
                    <button className="bg-rb-green dark:bg-rb-green text-white dark:text-white py-2 px-3 rounded-md text-sm font-bold" type='button' onClick={() => push(new ReportSection)}>Add new section</button>
                  </div>
                )}
              </Fragment>
            )}
            </FieldArray>
          </div>
        )
      }
    </div>
  )
})